import {Body} from 'shells/typography/body';

interface Props {
    children: string;
}

export function SummaryFieldLabel(props: Props) {
    return (
        <Body color='dark' size='small' isBold={true} nowrap={true}>
            {props.children}
        </Body>
    );
}
